import React from "react";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import { useSearchParams } from "react-router-dom";
import usePaginationState from "../../customHooks/usePaginationHook";

const CutPieceComponent = loadable(() => import("../../components/CutPiece"));

type Props = {};

const CutPiece = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";

  const { data: cutPieceData, isPending: cutPieceLoading } = useGetHook({
    queryKey: [`cut_piece-${pageSize}-${offset}-${searchQuery}`],
    url: `${APIS.CUT_PIECE}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });
  return (
    <>
      <CutPieceComponent
        cutPieceData={cutPieceData}
        cutPieceLoading={cutPieceLoading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
      />
    </>
  );
};

export default CutPiece;
